import { connect } from "react-redux";

import ErrorDisplay from "./ErrorDisplay";

export default connect(state => ({
	errors: state.ablauf.errors,
	fehlertexte: state.fehlertexte,
	locale: state.current_locale_i18n_key
}))(ErrorDisplay);
